import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { getConfigVariable } from "../config/config";
import { parseFilter } from "colbi_web_ui/lib/utils";
import App from "../controllers/App/App";

const queries = (args) => {
    return [
        {
            resource: "translation_table_update_logs",
            args: {
                projectId: args.projectId,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                page: parseInt(args.page, 10) || 0,
                pageSize: parseInt(
                    args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                ),
            },
            isDatagridReq: true,
            body: "__typename,items { id,projectId,importId,fiscalYear,configSet,entityStructure,field,oldValue,newValue,createdAt,createdBy }, total, hasMore, filters { prop, name, type, list, disableOperators, mandatory }",
        },
    ].filter((q) => q);
};

const translationTableUpdateLogs = (path, navigation, exact, title) => ({
    path,
    navigation,
    component: App,
    exact,
    queries,
    title: [title],
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                items: "query(0).list",
                header: "query(0).header",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                showCheckbox: "query(0).showCheckbox",
                total: "query(0).metadata.total",
                modifierssx: {
                    "& .sovosPaginationFooter > :first-child": {
                        display: "none",
                    },
                },
            },
        },
    ],
});

export default translationTableUpdateLogs;
